import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Opp-Create-Before" }
const _hoisted_2 = { "txt-center": "" }
const _hoisted_3 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_image, {
          style: `height: 250px;`,
          src: _ctx.img
        }, null, 8, ["src"]),
        _cache[0] || (_cache[0] = _createElementVNode("h2", { "f-w-700": "" }, "Congratulations!", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("p", { "m-t-0": "" }, " Now that you have filled in your startup, entrepreneurial and personal information, it is time to shine and share opportunities with our entrepreneurial talent. ", -1))
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            "is-block": "",
            icon: "el-icon-check",
            onClick: _ctx.submit,
            type: "primary",
            size: "large"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Continue ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}